import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllPragaDoenca } from '../service';
import {
  LIST_PRAGA_DOENCA,
  LIST_PRAGA_DOENCA_PENDING,
  LIST_PRAGA_DOENCA_SUCCESS,
  LIST_PRAGA_DOENCA_FAILURE
} from '../actionTypes';

function* sagaListAllPragaDoenca() {
  yield put({ type: LIST_PRAGA_DOENCA_PENDING })

  try {
    const list = yield call(findAllPragaDoenca)
    yield put({ type: LIST_PRAGA_DOENCA_SUCCESS, list: list })

  } catch (error) {

    yield put({ type: LIST_PRAGA_DOENCA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllPragaDoenca() {
  yield takeLatest(LIST_PRAGA_DOENCA, sagaListAllPragaDoenca)
}